<template>
  <div class="overview">
    <h2 v-if="!isQrCodeOverview">總覽</h2>
    <div v-else style="margin-bottom: 20px !important;"></div>
    <MySwiper :breakpoints="breakpoints" hide-pagination class="mb-3">
      <MySwiperSlide v-for="overview in overviews" :key="overview.status">
        <OverviewItem
          :item="overview"
          @selected="$emit('select', $event)"
          :loading="loading"
          :paymentStatusName="paymentStatusName"
          :isQrCodeOverview="isQrCodeOverview"
        >
        </OverviewItem>
      </MySwiperSlide>
    </MySwiper>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MySwiper from '@/components/my-swiper/MySwiper.vue';
import MySwiperSlide from '@/components/my-swiper/MySwiperSlide.vue';
import vModelMixin from '../../mixins/v-model';
import OverviewItem from './OverviewItem.vue';

export default {
  name: 'Overview',
  mixins: [vModelMixin],
  components: {
    OverviewItem,
    MySwiper,
    MySwiperSlide,
  },
  props: {
    overviews: Array,
    className: {
      type: String,
      default: 'col-xl col-md-3 col-sm-6',
    },
    paymentStatusName: String,
    isQrCodeOverview: Boolean,
    loading: Boolean,
  },
  data: () => ({
  }),
  computed: {
    ...mapGetters(['role']),
    breakpoints() {
      return this.isQrCodeOverview
        ? {
          0: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
        }
        : {
          320: {
            slidesPerView: 2.2,
            spaceBetween: 10,
          },
          1096: {
            slidesPerView: 5.2,
          },
          1600: {
            slidesPerView: 7.2,
          },
        };
    },
  },
};
</script>

<style lang="scss" scoped>
.overview {
  h2 {
    color: #174169;
    font-size: 18px;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 25px;
    margin-bottom: 1rem;
  }
}
</style>
